
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.57 19.73l-2.33-4.31L29.92 1.5l2.88 5.33a3 3 0 002.88 5.31l2.89 5.32-5.18 2.81","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M28.78 18a3 3 0 004.1 1.22l2.88 5.32L10.08 38.5l-2.89-5.34a3 3 0 10-2.88-5.31l-2.88-5.31L27.11 8.62 30 14a3 3 0 00-1.22 4z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","stroke-dasharray":"2 2","d":"M20.01 12.68l8.42 15.7"}})])
          )
        }
      }
    